import { asType } from '@sparky/framework'
import aiops from './aiops'
import backbone from './backbone'
import aiopsFree from './aiopsFree'
import prisma_access from './prisma_access'
import iot from './iot'
import saas from './saas'
import sdwan from './sdwan'
import ng_casb from './ngCasb'
import ademx from './adem'
import rbi from './rbi'
import { getVarValue } from '../../common/utils/Sparky'

import type { ActivationManifest } from '../renderer'
import { FF_ENABLE_LOGGING_SERVICE, FF_ENABLE_PROFILE_ACTIVATION } from '../../common/utils/FeatureFlags'

export default asType<Record<string, ActivationManifest | undefined>>({
  aiops,
  'aiops-free': aiopsFree,
  prisma_access,
  backbone,
  iot,
  saas,
  'cgx': sdwan,
  ng_casb,
  ...(getVarValue(FF_ENABLE_LOGGING_SERVICE)) ? { 'cdl': require('./logging_service').default } : undefined,
  ...(getVarValue(FF_ENABLE_LOGGING_SERVICE)) ? { 'sls': require('./logging_service').default } : undefined,
  ...(getVarValue(FF_ENABLE_PROFILE_ACTIVATION)) ? { 'profile': require('./profile').default } : undefined,
  ademx,
  rbi
})
